<template>
  <q-card style="min-width: 360px">
    <q-card-section class="row items-center text-h6"
      >Aktivera användare</q-card-section
    >

    <q-separator />

    <q-card-section class="q-pa text-grey-8">
      Är du säker på att du vill aktivera {{ user.email }}?
    </q-card-section>

    <q-separator />

    <q-card-actions align="right">
      <q-btn
        flat
        label="Avbryt"
        @click="close"
        type="button"
        :disable="loading"
      />
      <q-btn
        label="Bekräfta"
        type="button"
        color="negative"
        @click="confirm"
        :loading="loading"
      />
    </q-card-actions>
  </q-card>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import { User } from '@/types/user'
export default defineComponent({
  name: 'MasterFormModal',

  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
    removeDeletedUser: {
      type: Function as PropType<(uuid: string) => Promise<null>>,
      required: true,
    },
  },

  emits: ['close'],

  setup(props, { emit }) {
    const loading = ref(false)

    function close() {
      emit('close')
    }

    async function confirm() {
      loading.value = true
      await props.removeDeletedUser(props.user.uuid)
      loading.value = false
      close()
    }

    return { close, confirm, loading }
  },
})
</script>
